module.exports = __webpack_public_path__ + "img/forms-doc.12f4d9fc.svg";